var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocumentWithDouble = function SvgDocumentWithDouble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgDocumentWithDouble",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgDocumentWithDouble{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "content",
    className: "svgDocumentWithDouble svgBase svgHover svgSelect",
    d: "M1.8,12.4h1v1h-1c-0.7,0-1-0.2-1-1L0.8,2c0-0.7,0.3-1.2,1-1.2h11.6c0.7,0,1,0.2,1,1v1h-1v-1H1.8 V12.4l0.4,0.2L1.8,12.4z M17.2,4.6v11.6c0,0.7-0.2,1-1,1H4.7c-0.7,0-1-0.2-1-1V4.6c0-0.7,0.2-1,1-1h11.6c0.7,0,1,0.4,1,1.1l0,0 L17.2,4.6z M16.3,4.6H4.7v11.6h11.6V4.6z M5.6,7.5h3.9c0.1,0-0.2-0.5,0,0v-1l0,0c0-0.1,0.1,0,0,0H5.6c-0.1,0,0-0.1,0,0L5.6,7.5 C5.6,7.6,5.6,7.5,5.6,7.5z M5.6,10.4h6.8c0.1,0-0.1-0.1,0,0v-1c0,0,0,0,0,0c0-0.1,0.1,0,0,0H5.6c-0.1,0,0-0.1,0,0L5.6,10.4 C5.6,10.5,5,9.9,5.6,10.4z M5.6,13.3h8.7c0.1,0,0,0.1,0,0v-1c-0.5-0.2,0,0,0,0c-0.4-0.2,0.1,0,0,0H5.6c-0.1,0,0-0.1,0,0V13.3 C5.6,13.4,4.7,12.5,5.6,13.3z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocumentWithDouble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document_with_double.a8f54f17.svg";
export { ForwardRef as ReactComponent };